import React from "react";
import {Box, Columns, Heading, Table} from "react-bulma-components";
import Collapsible from "react-collapsible";
import {useTrackingCategoryData} from "../../../hooks/useTrackingCategoryData";
import {getDataFresh, getTrackingCategoriesData, getTrackingOptionsData} from "../../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import {useTrackingOptionsData} from "../../../hooks/useTrackingOptionsData";
import LoadingSpinner from "../../Utils/Spinner";
import Option from "./Option";
import NewCategory from "./NewCategory";
import axios from "axios";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {NotificationManager} from "react-notifications";
import {formatXeroData, sendXeroData} from "../../../utils";


export default function TrackingCategory(props){
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    let categoriesLoaded = useTrackingCategoryData({}, dataFresh);
    let optionsLoaded = useTrackingOptionsData({}, dataFresh);
    let categories = useSelector(getTrackingCategoriesData);
    let options = useSelector(getTrackingOptionsData);

    if(!categoriesLoaded || !optionsLoaded){
        return <LoadingSpinner />
    }

    const onSave = ((data) => {
        const conf = {
            url: props.endpoint+"createtrackingcategory",
            method: "post",
            data: data
        };
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            let category = formatXeroData(res.data, "TK");
            console.log(category);
            sendXeroData(category, "XeroTrackingCategories").catch(err => {
                console.log(err);
                NotificationManager.error("There was an error sending data to Xero");
            })
        }).catch(err => {
            NotificationManager.error("There was an error creating tracking category");
        })
    })

    return (
        <div>
            <br/>
            <NewCategory onSave={onSave}/>
            <Box>
                <Collapsible
                    trigger={"Tracking Categories"}
                    triggerOpenedClassName={"title"}
                    className={"title"}
                >
                    {categories.results.map((category) => (
                        <Option
                            category={category}
                            options={options}
                        />
                    ))}
                </Collapsible>
            </Box>
        </div>
    )
}